import { render, staticRenderFns } from "./HubMatchmakingStatus.vue?vue&type=template&id=253ca16a&scoped=true"
import script from "./HubMatchmakingStatus.vue?vue&type=script&lang=js"
export * from "./HubMatchmakingStatus.vue?vue&type=script&lang=js"
import style0 from "./HubMatchmakingStatus.vue?vue&type=style&index=0&id=253ca16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ca16a",
  null
  
)

export default component.exports